import { render, staticRenderFns } from "./TodayData.vue?vue&type=template&id=d71b5588&scoped=true"
import script from "./TodayData.vue?vue&type=script&lang=js"
export * from "./TodayData.vue?vue&type=script&lang=js"
import style0 from "./TodayData.vue?vue&type=style&index=0&id=d71b5588&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d71b5588",
  null
  
)

export default component.exports